import { useMemo } from 'react';
import { CONFIG } from '~/_shared/constants/config';
import { DESKTOP_VERSION_WIDTH_THRESHOLD } from '~/_shared/utils/deviceDetect/deviceDetect.helpers';
import { useDeviceInfoScreenWidthSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';

export const useIsExportReportAvailable = () => {
  const isMapPresentational = useIsMapPresentationalSelector();
  const screenWidth = useDeviceInfoScreenWidthSelector();

  const isExportReportAvailable = useMemo(() => {
    return CONFIG.ENABLE_PDF_EXPORT && !isMapPresentational && screenWidth >= DESKTOP_VERSION_WIDTH_THRESHOLD;
  }, [isMapPresentational, screenWidth]);

  return {
    isExportReportAvailable,
  };
};
